import { useContext, useMemo } from 'react';
import { ConcernsContext } from '../../lib/context/ConcernsContext';
import { Codes } from '../smartsend/SmartSendSocketsModels';
import BannersItem from './banners-item';
import { GetSocketDescription } from '../importstatus/GetSocketDescription';
import { onlyUnique } from '../../lib/helpers/ArrayHelper';
import { DashHome, SettingsCache } from '~/lib/consts/settings-cache';
import { P2GBox, P2GContainer, P2GText, P2GLink, P2GImage, P2GDivider } from '@parcel2go/core-ui';
import { RoutingConstants } from '../../lib/consts/RoutingConstants';

interface props {
  tab: string;
  isXs: boolean;
}

export default function Banners(props: props) {
  const ctx = useContext(ConcernsContext);

  const widerIssues = useMemo(() => {
    let output: string[] = [];

    ctx.state.Sockets &&
      (output = ctx.state.Sockets.filter(
        (s) => s.Details?.Code === Codes.WiderIssue && s.Details?.Stage === 'update'
      ).map((x) => GetSocketDescription(x.Details)));

    SettingsCache.settings.Features.includes('eBayDispatchIssuesBanner') &&
      output.push(GetSocketDescription({ Code: Codes.WiderIssue, MarketplaceSource: 'ebay', Stage: 'update' }));

    SettingsCache.settings.Features.includes('eBayImportIssuesBanner') &&
      output.push(GetSocketDescription({ Code: Codes.WiderIssue, MarketplaceSource: 'ebay', Stage: 'import' }));

    return output.filter((x) => !!x).filter(onlyUnique);
  }, [ctx.state.Sockets]);

  const shouldShowMarketingBanner = useMemo(() => {
    try {
      if (!SettingsCache.settings.Features.includes('Banners')) {
        return false;
      }

      // Only Show for P2G Main SmartSend, not eBay etc
      const okHrefPaths = ['/my/smartsend/', 'localhost'];

      // Dashboard and NewOrders Only
      const okTabs = [DashHome, RoutingConstants.SmartSend];

      return okHrefPaths.find((x) => window.location.href.indexOf(x) > -1) && okTabs.includes(props.tab);
    } catch {
      return false;
    }
  }, [props.tab]);

  const shouldShowOldToolBanner = useMemo(() => {
    try {
      if (
        !SettingsCache.settings.Features.includes('BannerBackToOldTool') ||
        !SettingsCache.settings.SmartSend.LegacyName
      ) {
        return false;
      }

      // Dashboard and NewOrders Only
      const okTabs = [DashHome, RoutingConstants.SmartSend];

      // Hardcode to DHL to be safe
      const isDHL = SettingsCache.profile?.toUpperCase().includes('DHLPARCEL');
      return okTabs.includes(props.tab) && isDHL;
    } catch {
      return false;
    }
  }, [props.tab]);

  // Only show between 10th Nov and 24th Dec and if we have a link.
  const lastPostingBanner = useMemo(() => {
    if (!SettingsCache.settings.Links?.LastPostingDates) {
      return null;
    }

    const date = new Date();
    return (date.getMonth() == 10 && date.getDate() > 10) || (date.getMonth() == 11 && date.getDate() < 25)
      ? SettingsCache.settings.Links?.LastPostingDates
      : null;
  }, []);

  return (
    <>
      {lastPostingBanner && (
        <P2GBox backgroundColour="rgb(226, 238, 246)" pt={2} pb={2}>
          <P2GContainer maxWidth="lg">
            <P2GBox textAlign="center">
              <P2GText>
                <P2GLink href={lastPostingBanner} target="_blank">
                  Last posting dates
                </P2GLink>{' '}
                for Christmas {new Date().getFullYear()}
              </P2GText>
            </P2GBox>
          </P2GContainer>
        </P2GBox>
      )}
      {shouldShowMarketingBanner && widerIssues.length == 0 && (
        <P2GBox backgroundColour="#0083D5" pt={1} pb={1}>
          <P2GContainer maxWidth="lg">
            <P2GImage
              style={{ width: '100%' }}
              src="https://content.parcelsolutions.net/42c5534b-0f47-4342-80f0-8f21203f0669/smart-send/promo/evri-special-price.png"
              alt="EVRi Savers"
            />
          </P2GContainer>
        </P2GBox>
      )}
      {shouldShowOldToolBanner && widerIssues.length == 0 && (
        <P2GBox pt={2} pb={1} textAlign={'right'}>
          <P2GContainer maxWidth="lg">
            <P2GLink href="/myaccount/uploadeditems/revert">
              Switch to <strong>{SettingsCache.settings.SmartSend.LegacyName}</strong>
            </P2GLink>
          </P2GContainer>
        </P2GBox>
      )}
      {widerIssues.length > 0 && (
        <P2GBox backgroundColour="#f9f9f9" pt={1} pb={1}>
          <P2GContainer maxWidth="lg">
            {widerIssues.map((e) => (
              <BannersItem isXs={props.isXs} message={e} key={e} />
            ))}
          </P2GContainer>
          <P2GDivider />
        </P2GBox>
      )}
    </>
  );
}
